import { createSlice } from "@reduxjs/toolkit";
export const initialState = {
  menu: [],
  showMenu: [],
  allItems: [],
  cart: [],
  popular: [],
  recommendations: [],
  selectedItem: {},
  selectedItemIndexForEdit: {},
  supportedLanguages: [],
  selectedLanguage: { key: "en", val: "English" },
  selectedCategoryIndex: 0,
  selectedSubCategoryIndex: 0,
  restaurantCode: "",
  tableNumber: "",
  searchText: "",
  toastMessage: "",
  restaurantInfo: "",
  showSearch: false,
  activemMenuIndex: 0,
  checksCount: 0,
  splitPaymentData: {},
  logedinUserDetails: {},
  logedinUser: false,
  prePlaceTheOrderOfficeData: {},
  postPlaceTheOrderOfficeData: {},
  checksData: [],
  reservationInputs: {},
  reservationData: {},
  chargeToRoomStep: 1,
  faceRecogRoomStep: 1,
  signatureBase64: {},
  paymentPayload: {},
  presentUniqueTotalTags: [],
  selectedFilters: [],
  selectedOrdersTab: 0,
  profileMeandatory: false,
};

const homePageSlice = createSlice({
  name: "homePage",
  initialState,
  reducers: {
    setSelectedLanguage(state, action) {
      state.selectedLanguage = action.payload;
    },
    setSupportedLanguages(state, action) {
      state.supportedLanguages = action.payload;
    },
    setSelectedCategory(state, action) {
      state.selectedCategoryIndex = parseInt(action.payload);
    },
    setSelectedSubCategory(state, action) {
      state.selectedSubCategoryIndex = parseInt(action.payload);
    },
    setMenu(state, action) {
      state.menu = action.payload;
    },
    setShowMenu(state, action) {
      state.showMenu = action.payload;
    },
    setSelectedItem(state, action) {
      state.selectedItem = action.payload;
    },
    setSelectedItemIndexForEdit(state, action) {
      state.selectedItemIndexForEdit = action.payload;
    },
    setCart(state, action) {
      state.cart = action.payload;
    },
    setTableNumber(state, action) {
      state.tableNumber = action.payload;
    },
    setRestaurentCode(state, action) {
      state.restaurantCode = action.payload;
    },
    setRestaurentInfo(state, action) {
      state.restaurantInfo = action.payload;
    },
    addToCart(state, action) {
      const indexOfAddingItem = action.payload;
      state.cart[indexOfAddingItem].quantity =
        state.cart[indexOfAddingItem].quantity + 1;
    },
    updateCart(state, action) {
      const { quantity, instruction, customizations, individualCusto } =
        action.payload;
      state.cart[state.selectedItemIndexForEdit].quantity = quantity;
      state.cart[state.selectedItemIndexForEdit].instruction = instruction;
      state.cart[state.selectedItemIndexForEdit].customizations =
        customizations;
      state.cart[state.selectedItemIndexForEdit].individualCusto =
        individualCusto;
    },
    removeFromCart(state, action) {
      const indexOfRemovingItem = action.payload;

      if (indexOfRemovingItem < 0) {
      } else {
        if (state.cart[indexOfRemovingItem].quantity <= 1) {
          // state.cart.splice(indexOfRemovingItem, 1);
        } else {
          state.cart[indexOfRemovingItem].quantity =
            state.cart[indexOfRemovingItem].quantity - 1;
        }
      }
    },
    deleteItemFromCart(state, action) {
      const indexOfRemovingItem = action.payload;
      state.cart.splice(indexOfRemovingItem, 1);
    },
    setSearchText(state, action) {
      state.searchText = action.payload;
    },
    setToastMessage(state, action) {
      state.toastMessage = action.payload;
    },
    setShowSearchModal(state, action) {
      state.showSearch = action.payload;
    },

    setPopular(state, action) {
      state.popular = action.payload;
    },

    setRecommendations(state, action) {
      state.recommendations = action.payload;
    },
    setAllItems(state, action) {
      state.allItems = action.payload;
    },
    setActivemMenuIndex(state, action) {
      state.activemMenuIndex = action.payload;
    },
    setChecksCount(state, action) {
      state.checksCount = action.payload;
    },

    setLogedinUserData(state, action) {
      state.logedinUserDetails = action.payload;
    },
    setLogedinUser(state, action) {
      state.logedinUser = action.payload;
    },

    resetState(state, action) {
      // state = initialState;
      // state = action.payload;
      state.menu = [];
      state.cart = [];
      //       {
      //   menu: [],
      //   cart: [],
      //   selectedItem: {},
      //   selectedItemIndexForEdit: {},
      //   selectedLanguage: 'English',
      //   selectedCategoryIndex: 0,
      //   restaurantCode: '',
      //   tableNumber: '',
      //   searchText: '',
      //   restaurantInfo: '',
      // }
    },
    reset: (state) => {
      return initialState;
    },
    setSplitPaymentData(state, action) {
      state.splitPaymentData = action.payload;
    },
    setprePlaceTheOrderOfficeData(state, action) {
      state.prePlaceTheOrderOfficeData = action.payload;
    },
    setpostPlaceTheOrderOfficeData(state, action) {
      state.postPlaceTheOrderOfficeData = action.payload;
    },
    setchecksData(state, action) {
      state.checksData = action.payload;
    },
    setreservationInputs(state, action) {
      state.reservationInputs = action.payload;
    },
    setreservationData(state, action) {
      state.reservationData = action.payload;
    },
    setchargeToRoomStep(state, action) {
      state.chargeToRoomStep = action.payload;
    },
    setfaceRecogRoomStep(state, action) {
      state.faceRecogRoomStep = action.payload;
    },
    setsignatureBase64(state, action) {
      state.signatureBase64 = action.payload;
    },
    setPaytabPayload(state, action) {
      state.paymentPayload = action.payload;
    },
    setPresentUniqueTotalTags(state, action) {
      state.presentUniqueTotalTags = action.payload;
    },
    setSelectedFilters(state, action) {
      state.selectedFilters = action.payload;
    },
    setSelectedOrdersTab(state, action) {
      state.selectedOrdersTab = action.payload;
    },
    setProfileMeandatory(state, action) {
      state.profileMeandatory = action.payload;
    },
  },
});

// export const { actions: homePageActions } = slice;

// export const useHomePageSlice = () => {
//   useInjectReducer({ key: slice.name, reducer: slice.reducer });
//   return { actions: slice.actions };
// };

// Action creators are generated for each case reducer function
export const {
  setSelectedLanguage,
  setSelectedCategory,
  setSelectedSubCategory,
  setMenu,
  setShowMenu,
  setSelectedItem,
  setSelectedItemIndexForEdit,
  setCart,
  setTableNumber,
  setRestaurentCode,
  setRestaurentInfo,
  addToCart,
  updateCart,
  removeFromCart,
  deleteItemFromCart,
  setSearchText,
  setToastMessage,
  resetState,
  reset,
  setSupportedLanguages,
  setShowSearchModal,
  setPopular,
  setRecommendations,
  setAllItems,
  setActivemMenuIndex,
  setChecksCount,
  setSplitPaymentData,
  setLogedinUserData,
  setLogedinUser,
  setprePlaceTheOrderOfficeData,
  setpostPlaceTheOrderOfficeData,
  setchecksData,
  setreservationInputs,
  setreservationData,
  setchargeToRoomStep,
  setfaceRecogRoomStep,
  setsignatureBase64,
  setPaytabPayload,
  setPresentUniqueTotalTags,
  setSelectedFilters,
  setSelectedOrdersTab,
  setProfileMeandatory,
} = homePageSlice.actions;

export default homePageSlice.reducer;
